module.exports = __webpack_public_path__ + "img/15-2.2f46a51c.png";